import { KeyValueModel } from "model";
import { EnumFiltrarPor } from "model/enums/enum-filtrar-por";

export const TpFiltrarPorMock: KeyValueModel[] = [
    new KeyValueModel(EnumFiltrarPor.DATA_VENCIMENTO, "Data de Vencimento"),
    new KeyValueModel(EnumFiltrarPor.DATA_PAGAMENTO, "Data de Pagamento"),
];
